import Chatbot from "react-chatbot-kit";

import "./Chat.scss";
import "./Chat.css";
import MessageParser from "./MessageParser";
import ActionProvider from "./ActionProvider";
import config from "./Config";

export default function Chat({ menuOpen, setmenuOpen }) {
  return (
    <div className={"menu " + (menuOpen && "active")}>
      <div className="menu-header">
        <div className="menu-header-title">
          <h1>Contact Me</h1>
          <p>Via AnuragBOT</p>
        </div>
        <div className="menu-header-close" onClick={() => setmenuOpen(false)}>
          <i className="fas fa-times icon"></i>
        </div>
      </div>

      <div className="chatbox">
        <Chatbot
          config={config}
          messageParser={MessageParser}
          actionProvider={ActionProvider}
        />
      </div>
    </div>
  );
}
